import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { useSubscriptionUsage } from 'context/subscription-usage'
import {
    ACCOUNT_PLAN_PATH,
    ENABLE_FREE_PLAN_USAGE_UI,
    formatChipText,
    formatChipTextCompact,
    getWorstTone,
    isFreeTier,
} from 'utility/subscription-usage'

const Chip = styled(Link)`
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 4px 10px;
    border-radius: 999px;
    font-size: 12px;
    font-weight: 600;
    text-decoration: none;
    white-space: nowrap;
    border: 1px solid;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1.2;
    .dot {
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: currentColor;
        flex-shrink: 0;
    }
    .label {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        min-width: 0;
    }
    &.ok {
        background: #eff6ff;
        border-color: #bfdbfe;
        color: #1d4ed8;
    }
    &.warn {
        background: #fffbeb;
        border-color: #fde68a;
        color: #92400e;
    }
    &.over {
        background: #fef2f2;
        border-color: #fecaca;
        color: #991b1b;
    }
    /* Prefer compact text until header has room */
    .full {
        display: none;
    }
    .compact {
        display: inline;
    }
    @media (min-width: 1400px) {
        .full {
            display: inline;
        }
        .compact {
            display: none;
        }
    }
    @media (max-width: 930px) {
        font-size: 11px;
        padding: 3px 8px;
        max-width: 170px;
    }
`

export const PlanUsageChip = () => {
    const { freeUsage } = useSubscriptionUsage()
    if (!ENABLE_FREE_PLAN_USAGE_UI) return null
    if (!freeUsage || !isFreeTier(freeUsage.tier)) return null
    const fullText = formatChipText(freeUsage)
    const compactText = formatChipTextCompact(freeUsage)
    if (!fullText) return null
    const tone = getWorstTone(freeUsage)
    return (
        <Chip to={ACCOUNT_PLAN_PATH} className={tone} title={fullText}>
            <span className="dot" />
            <span className="label">
                <span className="full">{fullText}</span>
                <span className="compact">{compactText}</span>
            </span>
        </Chip>
    )
}
